/** Queries for 'City' */

import { tag } from 'api/rtkTags'
// eslint-disable-next-line
import { initialCity } from 'constants/initialValues'
import { label } from 'constants/labels'

export const queryGetPagedCity = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'grad',
      data: {
        pageNumber,
        pageSize,
        options
      }
    },
    providesTags: {
      type: tag.city
    }
  }
}

export const queryGetAllCity = (options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'grad',
      data: { options }
    },
    providesTags: {
      type: tag.city
    }
  }
}

/**
 * @param {initialCity} data
 */
export const queryAddCity = data => {
  return {
    query: {
      name: 'data',
      mode: 'new',
      type: 'grad',
      data: { values: data }
    },
    invalidatesTags: [tag.city],
    successMsg: label.successMsgCreate + ' ' + label.msgCity
  }
}

/**
* @param {initialCity} data
@param {string} id
*/
export const queryUpdateCity = (data, id) => {
  return {
    query: {
      name: 'data',
      mode: 'update',
      type: 'grad',
      data: {
        values: data,
        options: {
          where: {
            id
          }
        }
      }
    },
    invalidatesTags: [tag.city],
    successMsg: label.successMsgEdit + ' ' + label.msgCity
  }
}
/**
@param {string} id
*/
export const queryDeleteCity = id => {
  return {
    query: {
      name: 'data',
      mode: 'delete',
      type: 'grad',
      data: {
        options: {
          where: { id }
        }
      }
    },
    invalidatesTags: [tag.city],
    successMsg: label.successMsgDelete + ' ' + label.msgCity
  }
}
